export enum Gender {
  Male = 'male',
  Female = 'female',
}

export enum Lange {
  PL = 'PL',
  EN = 'EN',
  UA = 'UA',
  RU = 'RU',
  GE = 'GE',
  TR = 'TR',
  TJ = 'TJ',
  BY = 'BY',
  UZ = 'UZ',
  DE = 'DE',
  AR = 'AR',
  SQ = 'SQ',
  SK = 'SK',
  LT = 'LT',
  ES = 'ES',
  FR = 'FR',
  VN = 'VN',
  PH = 'PH',
  RO = 'RO',
  HI = 'HI',
}

export type TestConfiguration = {
  lange: Lange;
  gender: Gender;
  public: boolean;
};
